/**
 * Tabla «cómo sale cada cantidad» de un combo calculado (spec 20): la misma lectura que la ventana «Agregar combo o
 * receta» del punto de venta. La usa «Probar» en la configuración para que la dueña compare con su Excel.
 */
import { formatearCantidad, Money, type RenglonComboDTO } from '@mg/shared';
import { Badge } from '@/componentes/ui/badge.tsx';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/componentes/ui/table.tsx';

export function VistaPreviaCombo({ renglones, testid = 'combo-prueba-tabla' }: { renglones: RenglonComboDTO[]; testid?: string }) {
  return (
    <Table data-testid={testid}>
      <TableHeader>
        <TableRow>
          <TableHead>Producto</TableHead>
          <TableHead>Cómo sale la cantidad</TableHead>
          <TableHead className="text-right">Cantidad</TableHead>
          <TableHead className="text-right">Desc. combo</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {renglones.map((r) => (
          <TableRow key={r.presentacion_id} data-testid={`combo-prueba-${r.producto_codigo}`}>
            <TableCell>
              <span className="font-medium">{r.producto_nombre}</span> <span className="text-xs text-muted-foreground">{r.producto_codigo}</span>
              {r.empaque ? <Badge variant="neutro" className="ml-1">empaque</Badge> : null}
            </TableCell>
            <TableCell className="text-xs text-muted-foreground">{r.explicacion}</TableCell>
            <TableCell className="text-right num font-medium">{formatearCantidad(Money.parse(r.cantidad), 2)}</TableCell>
            <TableCell className="text-right num">{Money.parse(r.descuento_pct).esPositivo() ? `−${Money.parse(r.descuento_pct).toDisplay()} %` : <span className="text-muted-foreground">sin descuento</span>}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
